import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import StorageManager from '../management/StorageManager'
import StorageFillPosition from '../management/StorageFillPosition'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

const MainStorage = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Storages'),
      component: <StorageManager />,
      permissionCode: 'STORAGE TAB'
    },
    {
      title: t_('Initial configuration'),
      component: <StorageFillPosition />,
      permissionCode: 'INITIAL CONFIGURATION'
    }
  ]
  return <SmartNavigator componentsInfo={componentsInfo} />
}
export default MainStorage
